import { Product, ProductCountry } from '@app/models';
// const _ = require('lodash');

export const getDefaultFob = (product: any, productCountry: any) => {
  if (product && product.metadata && productCountry && productCountry.fobType) {
    if (
      product.metadata &&
      product.metadata.finalFOB &&
      product.metadata.finalFOB !== undefined &&
      product.metadata.finalFOB !== null
    ) {
      return parseFloat(product.metadata.finalFOB) || 0;
    }

    if (productCountry.fobType === 'customFOB') {
      return productCountry.customFOB || 0;
    } else {
      return product.metadata[productCountry.fobType] || 0;
    }
  } else {
    if (
      product.metadata &&
      product.metadata.finalFOB &&
      product.metadata.finalFOB !== undefined &&
      product.metadata.finalFOB !== null
    ) {
      return parseFloat(product.metadata.finalFOB) || 0;
    }
    return 0;
  }
};

export const getFob = (
  product: any,
  productCountry: any,
  shipment: any,
  enableShipments: boolean
) => {
  if (enableShipments && shipment && shipment.fob) {
    return (shipment && shipment.fob) || 0;
  } else if (
    product &&
    product.metadata &&
    productCountry &&
    productCountry.fobType
  ) {
    if (productCountry.fobType === 'customFOB') {
      return productCountry.customFOB || 0;
    } else if (productCountry.fobType === 'regionalFOB') {
      return (
        product.metadata['finalFOB'] || product.metadata['initialFOB'] || 0
      );
    } else {
      return product.metadata[productCountry.fobType] || 0;
    }
  } else {
    if (
      product.metadata &&
      product.metadata.finalFOB &&
      product.metadata.finalFOB !== undefined &&
      product.metadata.finalFOB !== null
    ) {
      return parseFloat(product.metadata.finalFOB) || 0;
    }

    return 0;
  }
};

export const getCountryFOB = (product, productCountry, followType) => {
  const meta = productCountry && productCountry.metadata;
  const productMeta = product && product.metadata;

  if (meta && meta.fobType) {
    // console.log('productCountry has fobType', meta.fobType);
    return productMeta[meta.fobType] || 0;
  }

  switch (followType) {
    case 'VESTUARIO':
      return meta['finalFOB'] || meta['initialFOB'] || 0;
    case 'HOGAR':
      return meta['closedFOB'] || meta['openFOB'] || meta['customFOB'] || 0;
    case 'PETS':
      return meta['closedFOB'] || meta['openFOB'] || 0;
    // case 'ELECTRO':
    //   const defaultFOB = fobs && fobs.find(fob => fob.default);
    //   return (productMeta && productMeta.fobType) || defaultFOB
    //     ? productMeta[defaultFOB.key]
    //     : 0;
    default:
      console.error('followType not provided');
      return 0;
  }
};

export const getExpectedUnits = (product, productCountry, chains) => {
  const unitsFields = chains.map(chain => {
    return `${chain.prefix} Units ${productCountry.businessUnit}`;
  });

  return unitsFields.reduce((sum, field) => {
    return (sum += productCountry.metadata[field] || 0);
  }, 0);
};

export const getTotalFob = (
  product,
  productCountry,
  shipments,
  enableShipments
) => {
  return enableShipments
    ? (shipments || []).reduce((sum, shipment) => {
        return (
          sum +
          getFob(product, productCountry, shipment, enableShipments) *
            (shipment.units || 0)
        );
      }, 0)
    : ((productCountry && productCountry.expectedUnits) || 0) *
        getFob(product, productCountry, null, false);
};

export const getLocalCost = (
  product,
  productCountry,
  chain,
  shipments,
  enableShipments,
  follow
) => {
  const CountryId = productCountry && productCountry.CountryId;
  const businessUnit = productCountry && productCountry.businessUnit;

  const followCountryFactorObject =
    follow &&
    follow.Factors &&
    follow.Factors.find(
      f => f.CountryId === CountryId && f.businessUnit === businessUnit
    );

  const factor =
    productCountry.factor ||
    ((followCountryFactorObject && followCountryFactorObject.value) || 0);

  const exchangeObject =
    (CountryId &&
      follow &&
      follow.ExchangeRates &&
      follow.ExchangeRates.find(
        t => t.CountryId === CountryId && t.businessUnit === businessUnit
      )) ||
    1;
  const exchange = (exchangeObject && exchangeObject.value) || 1;
  return (
    getTotalFob(product, productCountry, shipments, enableShipments) *
    exchange *
    factor
  );
};

export const getLocalNetSale = (
  product,
  productCountry,
  chain,
  shipments,
  enableShipments,
  follow
) => {
  if (!chain.semesters && !enableShipments) {
    const CountryId = productCountry && productCountry.CountryId;

    const taxObject =
      CountryId &&
      follow &&
      follow.Taxes &&
      follow.Taxes.find(t => t.CountryId === CountryId);

    const tax = (taxObject && taxObject.value) || 0;

    const pvp =
      (productCountry &&
        productCountry.metadata &&
        productCountry.metadata.pvp) ||
      0;

    const units = (productCountry && productCountry.expectedUnits) || 0;
    return units * (pvp / (1 + tax / 100));
  } else {
    return 99999;
  }
};

export const getUSDNetSale = (
  product,
  productCountry,
  chain,
  shipments,
  enableShipments,
  follow
) => {
  if (!chain.semesters && !enableShipments) {
    const CountryId = productCountry && productCountry.CountryId;
    const businessUnit = productCountry && productCountry.businessUnit;
    const exchangeObject =
      (CountryId &&
        follow &&
        follow.ExchangeRates &&
        follow.ExchangeRates.find(
          t => t.CountryId === CountryId && t.businessUnit === businessUnit
        )) ||
      1;
    const exchange = (exchangeObject && exchangeObject.value) || 1;

    return (
      getLocalNetSale(
        product,
        productCountry,
        chain,
        shipments,
        enableShipments,
        follow
      ) / exchange
    );
  } else {
    return 99999;
  }
};

export const getComposedDescriptionColor = product => {
  // product.Colors
   return product && product.metadata.colors
    ? `${product.description} ${product.metadata.colors.map(c => c).join(' ')}`
    : product
    ? `${product.description}`
    : null;
};

export const isComponent = product =>
  product &&
  product.metadata &&
  (
    product.metadata.productType &&
    product.metadata.productType.toUpperCase().includes('COMPONENTE')
  ||
    product.metadata.productTypeClothing &&
    product.metadata.productTypeClothing.toUpperCase().includes('COMPONENTE')
  )
  ;

export const getImu = (
  product: Product,
  productCountry: ProductCountry,
  shipments,
  useShipments: boolean
) => {
  const fob = getFob(product, productCountry, shipments, useShipments);
  if (
    product &&
    productCountry &&
    product.metadata &&
    productCountry.metadata &&
    productCountry.metadata.pvp &&
    fob
  ) {
    const factor = productCountry.factor || productCountry.followCountryFactor;

    return (
      1 -
      (fob *
        factor *
        productCountry.followCountryExchangeRate *
        (1 + productCountry.followCountryTax / 100)) /
        productCountry.metadata.pvp
    );
  } else {
    return 0;
  }
};

export const getCbm = product => {
  // const metadata = product && product.metadata;
  // const height = (metadata && metadata.boxHeight) || 0;
  // const length = (metadata && metadata.boxLength) || 0;
  // const width = (metadata && metadata.boxWidth) || 0;

  // return (height * width * length) / 1000000;

  return (product && product.metadata && product.metadata.cbmPerCarton) || 0;
};

export const getTotalCountryShipmentUnits = (
  productCountry: ProductCountry,
  shipments: any[]
) => {
  if (productCountry && productCountry.shipments) {
    return shipments.reduce((sum, shipment) => {
      if (productCountry.shipments[shipment.value]) {
        return sum + productCountry.shipments[shipment.value];
      } else {
        return sum;
      }
    }, 0);
  } else {
    return 0;
  }
};

export const getContainers = totalCbm => {
  const containers = {
    HQ: {
      cbm: 65,
      cost: 1400
    },
    40: {
      cbm: 58,
      cost: 1400
    },
    20: {
      cbm: 28,
      cost: 1000
    },
    free: {
      cbm: 1,
      cost: 50
    }
  };

  const maxHQ = Math.ceil(totalCbm / containers['HQ'].cbm);
  const maxForty = Math.ceil(totalCbm / containers[40].cbm);
  const maxTwenty = Math.ceil(totalCbm / containers[20].cbm);

  const calcFromHq = (total, hq, forty, twenty, free, result?) => {
    result = result || [];

    let newHq = hq;
    let newForty;

    let newTwenty;
    let newFree;
    let newUnused;

    let rest = total;
    if (total >= 20) {
      rest = rest - newHq * containers['HQ'].cbm;
      if (newHq > 0 && rest > 0) {
        newForty = Math.floor(rest / containers[40].cbm);
      } else {
        newForty = forty || 0;
      }

      rest = rest - newForty * containers[40].cbm;
      if ((newForty > 0 || forty === null) && rest > 0) {
        newTwenty = Math.floor(rest / containers[20].cbm);
      } else {
        newTwenty = twenty || 0;
      }
      rest = rest - newTwenty * containers[20].cbm;

      newFree = rest >= 0 ? rest : 0;
      newUnused = rest <= 0 ? rest * -1 : 0;

      result.push({
        HQ: newHq,
        40: newForty,
        20: newTwenty,
        free: newFree,
        unused: newUnused,
        cbm: total + newUnused,
        totalCost:
          newHq * containers['HQ'].cost +
          newForty * containers[40].cost +
          newTwenty * containers[20].cost +
          newFree * containers['free'].cost
      });
    } else {
      newHq = 0;
      newForty = 0;
      newTwenty = 0;
      newFree = total;
      newUnused = 0;
    }

    result.push({
      HQ: newHq,
      40: newForty,
      20: newTwenty,
      free: newFree,
      unused: newUnused,
      cbm: total + newUnused,
      totalCost:
        newHq * containers['HQ'].cost +
        newForty * containers[40].cost +
        newTwenty * containers[20].cost +
        newFree * containers['free'].cost
    });

    if (newHq === 0 && newForty === 0 && newTwenty === 0) {
      const recommended = [];

      let res = [...result, ...recommended].sort(
        (a, b) =>
          ((a.recommendation && a.recommendation.cost) || a.totalCost) -
          ((b.recommendation && b.recommendation.cost) || b.totalCost)
      );

      res = res.filter(x => x.unused < 14).slice(0, 1);
      return res;
    }

    if (newHq - 1 > 0 && newHq - 1 > maxHQ - 4) {
      return calcFromHq(total, newHq - 1, forty, twenty, free, result);
    } else {
      if (forty === null) {
        return calcFromHq(total, 0, maxForty, twenty, free, result);
      } else if (newForty - 1 > 0 && newForty - 1 > maxForty - 4) {
        return calcFromHq(total, 0, newForty - 1, twenty, free, result);
      } else {
        if (twenty === null) {
          return calcFromHq(total, 0, 0, maxTwenty, free, result);
        } else if (newTwenty - 1 > 0 && newTwenty - 1 > maxTwenty - 4) {
          return calcFromHq(total, 0, 0, newTwenty - 1, free, result);
        } else {
          return calcFromHq(total, 0, 0, 0, free, result);
        }
      }
    }
  };

  return calcFromHq(Math.ceil(totalCbm), maxHQ, null, null, null);
};

export const hasConditions = (
  input: { product?: any; productCountry?: any },
  conditions: {
    businessUnits?: string[];
    countryCodes?: string[];
    followTypes?: string[];
  }
) => {
  const { product, productCountry } = input;
  const countryCode =
    productCountry && productCountry.Country && productCountry.Country.code;

  const businessUnit = productCountry && productCountry.businessUnit;

  const followType = product && product.followType;

  const { businessUnits, countryCodes, followTypes } = conditions;

  return (
    (followType && followTypes
      ? conditions.followTypes.includes(followType)
      : true) &&
    (countryCode && countryCodes ? countryCodes.includes(countryCode) : true) &&
    (businessUnit && businessUnits
      ? businessUnits.includes(businessUnit)
      : true)
  );
};
